/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import React, {memo} from "react";
import {Helmet} from "react-helmet";

interface MetaProps {
    name: "description" | "keywords" | "author";
    children: string;
}

const Meta = ({name, children}: MetaProps) => (
    <Helmet>
        <meta name={name} content={children} />
    </Helmet>
);

export default memo(Meta);
